import { useState, useEffect, ChangeEvent, Fragment } from 'react';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';

import { ReactComponent as FilterIcon } from '../assets/icons/main/filter-icon.svg';
import { ReactComponent as VrLine } from '../assets/icons/main/verticalLine.svg';
import { ReactComponent as RestoreIcon } from '../assets/icons/main/restore-icon.svg';

import SelectComponent from '../components/Select';

import Styles from '../theme/commonCss/Styles';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useOutletContext } from 'react-router-dom';
import { get } from 'lodash';


const OntologySelector = ({
  ontologyData,
  showLayout,
  onOntoFilterChange,
  isError,
  handleRefresh,
  ontoManageId,
  label,
  disabled,
  hideReset,
  reset,
  padding,
  hideBottomRow,
  hideLine
}: any) => {
  const [levelData, setLevelData] = useState<any>(ontologyData);
  // const [levelDataMain, setLevelDataMain] = useState<any>(ontologyData);
  const [isReset, setIsReset] = useState(false);
  const theme: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});

  // useEffect(() => {
  //   setLevelData(
  //     ontologyData.map((items: any, index: number) => {
  //       if (index === 0) {
  //         return { ...items, show: true };
  //       }
  //       return { ...items };
  //     })
  //   );
  //   setLevelDataMain(ontologyData);
  // }, [ontologyData]);


  const OntologySelectorStyles = {
    horizontal: {
      gridContainer: { display: 'flex', flexDirection: 'row' },
      box: { display: 'flex', flexDirection: 'row', width: '100%' },
      centerBox: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
      centerBox2: { display: 'flex', flexDirection: 'row', alignItems: 'baseline' },
      filterByText: {
        margin: '0 12px',
        color: theme.palette.text.primary,
        width: 'auto', minWidth: '80px', fontSize: '1rem'
      },
      vrLineGrid: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'end',
        alignItems: 'center',
        color: '#51648f',
      },
      vrLineGridIconButton: {
        marginLeft: '10px',
      },
    },
    vertical: {
      labelWrapper: {
        ...Styles.gridItem,
        '&.MuiGrid-item': {
          paddingTop: '22px !important',
        },
      },
      selectWrapper: { padding: '12px 0px !important' },
    },
  };

  const handleChange = (ontoValue: any, levelNum: number) => {
    setLevelData(
      levelData.map((items: any) => {
        if (items.level_number === levelNum) {
          return { ...items, selectedVal: ontoValue };
        }
        if (items.level_number === levelNum + 1) {
          const filteredData = ontologyData.filter((filterItems: any) => {
            return filterItems.level_number === levelNum + 1;
          });

          const filterOntology = filteredData[0].onto_manages.filter((filterItems: any) => {
            return filterItems.parent_id === ontoValue;
          });

          if (filterOntology.length > 0) {
            return { ...items, show: true, selectedVal: null, onto_manages: filterOntology };
          } else {
            return { ...items, show: false, onto_manages: [], selectedVal: null };
          }
        }

        if (items.level_number >= levelNum + 2) {
          if (items.onto_manages.length > 0) {
            return { ...items, show: false, onto_manages: [], selectedVal: null };
          }
        }
        return { ...items };
      })
    );

    onOntoFilterChange({ onto_manage_id: ontoValue, level_number: levelNum });
  };

  useEffect(() => {
    if (ontologyData.length) {
      if (ontoManageId) {
        const ontoManages = ontologyData.reduce((acc: any, onto: any) => {
          return [...acc, ...onto.onto_manages];
        }, []);

        const getOnto = ontoManages.find((ontoManage: any) => ontoManage.onto_manage_id === ontoManageId);

        if (getOnto) {
          const getOntoManages = ontoManages.reduce(
            (acc: any, onto: any) => {
              const lastItemParentId = acc[acc.length - 1].parent_id;
              if (onto.parent_id && lastItemParentId !== 0) {
                const ontoParent = ontoManages.find(
                  (ontoManage: any) => ontoManage.onto_manage_id === lastItemParentId
                );
                if (ontoParent) {
                  return [...acc, ontoParent];
                }
              }
              return acc;
            },
            [getOnto]
          );

          let foundOntoLevelNumber = 0;
          const getOntologies = ontologyData.reduce((acc: any, onto: any) => {
            const findOnto = onto.onto_manages.find((ontoManage: any) => {
              return getOntoManages.find(
                (ontoM: any) =>
                  ontoM.parent_id === ontoManage.onto_manage_id || ontoM.onto_manage_id === ontoManage.onto_manage_id
              );
            });
            if (findOnto) {
              foundOntoLevelNumber = onto.level_number;
              acc.push({
                ...onto,
                onto_manages: onto.onto_manages.filter(
                  (onto_manage: any) => onto_manage.parent_id === findOnto.parent_id
                ),
                selectedVal: findOnto.onto_manage_id,
                show: true,
              });
            } else if (foundOntoLevelNumber + 1 === onto.level_number && !disabled) {
              const filteredOntos = onto.onto_manages.filter(
                (onto_manage: any) => onto_manage.parent_id === getOnto.onto_manage_id
              );
              if (filteredOntos.length) {
                acc.push({
                  ...onto,
                  onto_manages: filteredOntos,
                  show: true,
                  selectedVal: null,
                });
              }
            } else {
              //(onto.level_number > foundOntoLevelNumber)
              acc.push({ ...onto });
            }
            return acc;
          }, []);
          setLevelData(getOntologies);
        }
      } else {
        setLevelData(
          ontologyData.map((items: any, index: number) => {
            if (index === 0) {
              return { ...items, show: true };
            }
            return { ...items };
          })
        );
        // setLevelDataMain(ontologyData);
      }
    }
  }, [disabled, ontoManageId, ontologyData]);

  useEffect(() => {
    if (isReset || reset) {
      setLevelData(
        ontologyData.map((items: any, index: number) => {
          if (index === 0) {
            return { ...items, show: true };
          }
          return { ...items };
        })
      );
      setIsReset(false);
    }
  }, [isReset, reset]);

  const handleFilterReload = () => {
    setLevelData([]);
    setIsReset(true);
    onOntoFilterChange({ onto_manage_id: 0, level_number: 0 });
    handleRefresh?.();
  };

  const mobileSize = useMediaQuery('(max-width:900px)');

  return (
    <>
      {showLayout ? (
        <Box sx={{ borderBottom: `1px solid ${!hideBottomRow && theme.palette.customBorderColor.main}` }}>
          <Grid container sx={{ p: padding ? padding : 4 }}>
            <Grid item xl={11} lg={11} md={11} sm={10} xs={8} sx={OntologySelectorStyles.horizontal.gridContainer}>
              <Box sx={OntologySelectorStyles.horizontal.box}>
                <Box sx={{ alignItems: 'center', display: 'flex', height: '42px' }}>
                  <Box sx={OntologySelectorStyles.horizontal.centerBox}>
                    {label || (
                      // <>
                      //   <FilterIcon stroke='#51648f' />
                      //   <Typography sx={OntologySelectorStyles.horizontal.filterByText}>Filter By :</Typography>
                      // </>
                      <Fragment>
                        <FilterIcon style={{ color: theme.palette.custom.light }} />
                        <Typography
                          sx={{
                            margin: '0 12px',
                            color: theme.palette.text.primary,
                            width: 'auto',
                            minWidth: '92px',
                            fontSize: '1rem',
                          }}
                        >
                          Filter By :
                        </Typography>
                      </Fragment>
                      // </>
                      // <Fragment>
                      //   <FilterIcon style={{ color: 'black' }} />
                      //   <Typography sx={OntologySelectorStyles.horizontal.filterByText}>Filter By :</Typography>
                    )}
                  </Box>
                </Box>

                <Grid container rowSpacing={4} columnSpacing={4}>
                  {levelData.map((items: any, index: number) =>
                    items.show ? (
                      <Grid item sm={12} md={6} lg={4} xl={3}>
                        <SelectComponent
                          key={items.level_number}
                          value={items.selectedVal || null}
                          name={levelData.level_name}
                          options={items['onto_manages'].map((onto: any) => ({
                            ...onto,
                            label: onto.onto_manage_title,
                            value: onto.onto_manage_id,
                          }))}
                          onChange={(event: ChangeEvent<HTMLSelectElement>) =>
                            handleChange(event.target.value, items.level_number)
                          }
                          placeholder={`Select ${items.level_name}`}
                          error={isError && !items.selectedVal}
                          // width='250px'
                          // sx={{ ml: 2 }}
                          disabled={disabled}
                          width='100%'
                        />
                      </Grid>
                    ) : (
                      ''
                    )
                  )}
                </Grid>
              </Box>
            </Grid>
            {!hideReset && (
              <Grid item xl={1} lg={1} md={1} sm={2} xs={4}>
                <Box
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    height: '42px',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                  }}
                >
                  {!hideLine && <VrLine style={{ color: theme.palette.customBorderColor.main }} />}
                  <IconButton onClick={handleFilterReload} sx={OntologySelectorStyles.horizontal.vrLineGridIconButton}>
                    <RestoreIcon />
                  </IconButton>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      ) : (
        levelData.map((items: any, idx: number) => {
          if (!items.show) return '';
          return (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                key={items.level_name}
                sx={{
                  ...Styles.gridItem,
                  // justifyContent: mobileSize ? 'flex-start' : 'flex-end',
                  padding: mobileSize ? '12px 0px 4px !important' : '22px 0px 0px !important',
                }}
              >
                <Typography sx={Styles.inputLabel} className={idx === 0 ? 'required-field' : ''}>
                  {items.level_name}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={8}
                sx={{ padding: mobileSize ? '0px 0px 12px !important' : '12px 0px !important' }}
              >
                <SelectComponent
                  value={items.selectedVal || ''}
                  name={levelData.level_name}
                  options={items['onto_manages'].map((onto: any) => ({
                    ...onto,
                    label: onto.onto_manage_title,
                    value: onto.onto_manage_id,
                  }))}
                  onChange={(event: ChangeEvent<HTMLSelectElement>) =>
                    handleChange(event.target.value, items.level_number)
                  }
                  placeholder={`Select ${items.level_name}`}
                  error={isError && !levelData[0].selectedVal}
                  helperText={`Please select ${items.level_name}`}
                  sx={{ textAlign: 'left' }}
                />
              </Grid>
            </>
          );
        })
      )}
    </>
  );
};

export default OntologySelector;
